import React, { createContext, useContext } from 'react';

// Temporarily simplified until BlockSuite API is properly configured

interface BlockSuiteContextType {
  collection: any | null;
  schema: any;
}

const BlockSuiteContext = createContext<BlockSuiteContextType | null>(null);

interface BlockSuiteProviderProps {
  children: React.ReactNode;
  workspaceId: string;
  documentId?: string;
}

export function BlockSuiteProvider({ children, workspaceId, documentId }: BlockSuiteProviderProps) {
  // Simplified provider that doesn't initialize BlockSuite yet
  const contextValue = {
    collection: null,
    schema: null,
  };

  return (
    <BlockSuiteContext.Provider value={contextValue}>
      {children}
    </BlockSuiteContext.Provider>
  );
}

export function useBlockSuite() {
  const context = useContext(BlockSuiteContext);
  if (!context) {
    throw new Error('useBlockSuite must be used within a BlockSuiteProvider');
  }
  return context;
}